import React from 'react'
import '../../../cssFiles/landingpage.scss';
import {Link} from 'react-router-dom';


let ProductCards = (props)=>{
    return <>
        <div  className="landing-container">
            <div className="cards-row">
            {props.plans.map((plan, idx) => (
                <div className={`card${plan.popular ? ' popular' : ''}`} key={plan.title}>
                {plan.popular && <div className="popular-badge">Most Popular</div>}
                <h2>{plan.title}</h2>
                <p className="landing_page_returns">{plan.returns}</p>
                <><br/><br/></>
                {/* {plan.brokerage ? <p className="brokerage">{plan.brokerage}</p>: <><br/><br/></>} */}
                <div className="price-section">
                    <span className="price">{plan.price}</span>
                    <span className="capital">{plan.stocks}</span>
                </div>
                {plan.timeLimit && <p className="stocks" dangerouslySetInnerHTML={{ __html: plan.timeLimit }}></p>}
                {/* {plan.timeLimit && <p className="stocks">{plan.timeLimit}</p>} */}
                <Link to={plan.mainPage}><button className="learn-btn">{plan.button}</button></Link>
                </div>
            ))}
            </div>

          {/* <Celebration/> */}

        </div>    
    </>
}

export default ProductCards